import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { Button } from 'rsuite'

import { isSuperUser } from '../../lib/supplier'
import { isOrderPriceLimitReached } from '../../lib/resources/price'
import { useAuth } from '../../services/useAuth'
import { Product } from '../../utils/types/Product'
import useRFQModal from '../Modals/hooks/useRFQModal'

import styles from '../../styles/ProductColumn.module.less'

interface AddProductButtonsSPPProps {
  isRFQProduct: boolean
  isLoading: boolean
  finalTotalPrice: number
  product: Product
  isOverExactStock: boolean
  onAddToCartClick: () => void
  className?: string
}
const analyticsLocation = 'single_product'

const AddProductButtonsSPP: FC<AddProductButtonsSPPProps> = (props) => {
  const {
    isRFQProduct,
    isLoading,
    isOverExactStock,
    finalTotalPrice,
    product,
    onAddToCartClick,
    className,
  } = props

  const { t } = useTranslation('products')
  const { user } = useAuth()
  const openRFQModal = useRFQModal({
    analyticsLocation,
    product,
  })

  // Allowing super user to add product to cart even if order amount greater than max price limit
  const isProductOrderLimitReached = !isSuperUser(user) && isOrderPriceLimitReached(
    finalTotalPrice, product,
  )

  const renderButtonText = () => {
    if (isRFQProduct) {
      return t('Request a quote')
    }

    if (isOverExactStock) {
      return t('Get restock notification')
    }

    return (isProductOrderLimitReached ? t('Request an order') : (
      <b>
        {t('Add to cart')}
      </b>
    ))
  }

  return (
    <div className={`${styles['checkout-button-wrapper']} ${className}`}>
      <div className={styles['quote-select-btns-wrapper']}>
        <Button
          appearance="primary"
          size="lg"
          block
          data-testid={isRFQProduct ? 'request-quote-button' : 'order-btn'}
          loading={isLoading}
          onClick={!isRFQProduct ? onAddToCartClick : () => openRFQModal()}
          className={styles['add-cart-button']}
        >
          {renderButtonText()}
        </Button>
      </div>
    </div>
  )
}

export default AddProductButtonsSPP
